import { Component, OnInit, NgZone } from '@angular/core';
import { AuthorizeErrorDialogComponent } from './authorize-error-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-authorize-error',
  templateUrl: './authorize-error.component.html',
  styleUrls: ['./authorize-error.component.css']
})
export class AuthorizeErrorComponent implements OnInit {

  authorizeModalRef: MatDialogRef<AuthorizeErrorDialogComponent>;

  constructor(private dialog: MatDialog, private router: Router, private zone: NgZone) { }

  ngOnInit() {
    console.log("authorize dialog oninit");
    this.authorizeModalRef = this.dialog.open(AuthorizeErrorDialogComponent, { width: '600px', height: '600px', disableClose: true, closeOnNavigation: false });
    this.authorizeModalRef.afterClosed().subscribe(result => {
      const pathIndex = top.location.href.indexOf(top.location.pathname);
      const rootPath = top.location.href.substring(0, pathIndex);
      top.location.href = rootPath;
    });
  }

}
